import React from 'react'

import * as S from './styles'

type Props = {
  type: string
  placeholder: string
}

const Input = ({ type, placeholder }: Props) => {
  return (
    <S.Wrapper>
      <input type={type} placeholder={placeholder} />
    </S.Wrapper>
  )
}

export default Input
